import styled, { css } from 'styled-components';

import { ReactComponent as ArrowUp } from 'assets/icons/arrow-up.svg';
import Button from 'components/common/Button';
import { SORT_DIR } from 'constants/constants';

export const TableWrapper = styled.div`
  display: grid;
  gap: 2.8rem;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  overflow-x: auto;
  transition: all 150ms ease-in-out;
  padding: 1.6rem 0;
  align-items: start;
  overflow: visible;
  th,
  td {
    max-width: 20rem;
    width: fit-content;
    position: relative;
  }
`;

export const ArrowIcon = styled(ArrowUp)`
  display: block;
  height: 1rem;
  transition: all 150ms ease-in-out;
  transform: ${({ direction }) =>
    direction === SORT_DIR.desc ? 'rotate(-180deg) translate(0, 10%)' : 'none'};
  width: 1.2rem;
  height: 1.2rem;
  opacity: ${({ $isSorting }) => ($isSorting ? '1' : '0.3')};
  path {
    stroke: ${({ theme, $isSorting }) =>
      $isSorting ? theme.new.colors.P500 : theme.new.colors.N900};
    stroke-width: 1.8px;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  background: ${({ theme }) => theme.new.colors.white};
  width: 100%;
  background-color: ${({ theme }) => theme.new.colors.N100};
`;

export const Column = styled.td`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  ${({ theme }) => theme.new.typography.p5};
  color: ${({ theme }) => theme.new.colors.N700};
`;

export const HeaderColumnContainer = styled.button`
  ${({ theme }) => theme.new.typography.p5SemiBold};
  align-items: center;
  color: ${({ theme }) => theme.new.colors.N600};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  font-size: 1.4rem;
  justify-content: start;
  width: fit-content;
`;

export const NewAssignmentButton = styled(Button)`
  border: none;
  color: ${({ theme }) => theme.new.colors.P500};
  ${({ theme }) => theme.new.typography.p4SemiBold};
  background: none;
  width: 20.5rem;
  height: 4.4rem;
  padding: 0;
  border-radius: 4px;
  ${({ disabled }) =>
    !disabled
      ? css`
          &:hover {
            color: ${({ theme }) => theme.new.colors.P900};
            svg path {
              stroke: ${({ theme }) => theme.new.colors.P900};
            }
          }
          &:focus {
            box-shadow: 0px 0px 0px 4px rgba(228, 229, 235, 0.4),
              0px 1px 2px 0px rgba(228, 229, 235, 0.05);
            color: ${({ theme }) => theme.new.colors.P500};
            svg path {
              stroke: ${({ theme }) => theme.new.colors.P500};
            }
          }
        `
      : css`
          cursor: not-allowed;
        `}

  svg {
    transform: ${`scale(${20 / 22})`};
    path {
      stroke-width: 2px;

      stroke: ${({ theme }) => theme.new.colors.P500};
    }
  }
`;

export const OptionsColumn = styled.th`
  opacity: 0;
  min-width: 5rem;
`;

export const NewAssignmentColumn = styled.tr`
  padding-left: 5.1rem !important;
  margin-top: 1.6rem;
  display: block;
`;
export const Row = styled.tr`
  height: ${({ height }) => height || '6.6rem'};
  text-align: left;
  width: 100%;
  td,
  th {
    &:first-child {
      padding-left: 5.1rem !important;
    }
  }
  td {
    &:first-child {
      min-width: 26.4rem;
    }
  }

  &:hover {
    ${({ isHeader }) =>
      !isHeader &&
      css`
        ${OptionsColumn} {
          opacity: 1;
        }
        background: ${({ theme }) => theme.new.colors.N200};
      `}
  }
`;
